/** CSS vars on the tldraw container for camera zoom (e.g. image hover scale). */
export const BOARD_CAMERA_Z_VAR = '--board-camera-z';
export const BOARD_INV_Z_VAR = '--board-inv-z';

/** Pin header title + icon on-screen size (counteracts camera zoom). */
export const BOARD_PIN_HEADER_SCREEN_PX = 12;

/**
 * Fixed pin header bar height on screen (icon + single-line title + padding).
 * Keeps header chrome from growing/shrinking with camera zoom.
 */
export const BOARD_PIN_HEADER_HEIGHT_SCREEN_PX = 30;

export function syncBoardCameraCssVars(container, zoom) {
  if (!container?.style) return;
  const z = Number(zoom);
  const safeZ = Number.isFinite(z) && z > 0 ? z : 1;
  container.style.setProperty(BOARD_CAMERA_Z_VAR, String(safeZ));
  container.style.setProperty(BOARD_INV_Z_VAR, String(1 / safeZ));
}

/** Screen-constant px on the board (counteracts camera zoom via CSS var). */
export function boardInvZoomPx(px, scale = 1) {
  return `calc(${px * scale}px * var(${BOARD_INV_Z_VAR}, 1))`;
}

export function boardPinHeaderScreenPx() {
  return boardInvZoomPx(BOARD_PIN_HEADER_SCREEN_PX);
}

export function boardPinHeaderHeightPx() {
  return boardInvZoomPx(BOARD_PIN_HEADER_HEIGHT_SCREEN_PX);
}

export function readBoardInvZoom(fromEl) {
  const root =
    fromEl?.closest?.('.tl-container') ||
    fromEl?.ownerDocument?.querySelector?.('.tl-container');
  if (!root) return 1;
  const raw = getComputedStyle(root).getPropertyValue(BOARD_INV_Z_VAR).trim();
  const value = Number(raw);
  return Number.isFinite(value) && value > 0 ? value : 1;
}
